module.exports = __webpack_public_path__ + "static/media/empty-image.d23d48ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/empty-image.svg
// module id = 277
// module chunks = 0